export const OPEN_PROJECT_SET = 'at/panels/project/OPEN_PROJECT_SET'
export const PROJECT_PANEL_OPENED_FROM_URL_SET = 'at/panels/project/PROJECT_PANEL_OPENED_FROM_URL_SET'
export const ALL_TASKS_ASSIGNED_SET = 'at/panels/project/ALL_TASKS_ASSIGNED_SET'
export const CAN_MANAGE_SET = 'at/panels/project/CAN_MANAGE_SET'

export const NEW_COMMENTS_ADD = 'at/panels/project/NEW_COMMENTS_ADD'
export const OLD_COMMENTS_ADD = 'at/panels/project/OLD_COMMENTS_ADD'
export const COMMENTS_INFO_CLEAR = 'at/panels/project/COMMENTS_INFO_CLEAR'
export const COMMENT_REMOVE = 'at/panels/project/COMMENT_REMOVE'
export const CHANGE_COMMENTS_ORDER = 'at/panels/project/CHANGE_COMMENTS_ORDER'
export const COMMENTS_LOADED_SET = 'at/panels/project/COMMENTS_LOADED_SET'
export const COMMENTS_LOADING_SET = 'at/panels/project/COMMENTS_LOADING_SET'
export const SENDING_COMMENT_SET = 'at/panels/project/SENDING_COMMENT_SET'
export const RECENTLY_ADDED_COMMENTS_ADD = 'at/panels/project/RECENTLY_ADDED_COMMENTS_ADD'
export const RECENTLY_ADDED_COMMENTS_REMOVE = 'at/panels/project/RECENTLY_ADDED_COMMENTS_REMOVE'
export const COMMENTS_SCROLL_TO_SET = 'at/panels/project/COMMENTS_SCROLL_TO_SET'
export const EDITING_COMMENT_ID_SET = 'at/panels/project/EDITING_COMMENT_ID_SET'
export const EDITING_COMMENT_TEXT_SET = 'at/panels/project/EDITING_COMMENT_TEXT_SET'
export const UPDATE_COMMENT = 'at/panels/project/UPDATE_COMMENT'
export const UPDATING_COMMENT_ID_SET = 'at/panels/project/UPDATING_COMMENT_ID_SET'
export const SHOW_NEW_COMMENT_INPUT_SET = 'at/panels/project/SHOW_NEW_COMMENT_INPUT_SET'
export const NEW_COMMENT_SET = 'at/panels/project/NEW_COMMENT_SET'
export const NEW_COMMENT_REMOVE = 'at/panels/project/NEW_COMMENT_REMOVE'



// WEBPACK FOOTER //
// ./web/js/panels/project/actionTypes.js